<template>
  <div>
    <HighlightContainerCheckout
      title="A compensação ambiental de embalagens da sua empresa está quase concluída!"
      subtitle="Agora é o momento de conferir todas as informações que você preencheu para finalizar a sua compra, e formalizar a nossa parceria. Vamos lá, falta pouco!"
      even
      class="pa-0"
    >
      <v-container class="purchase-summary-wrapper pa-0">
        <v-row>
          <v-col cols="12">
            <h3>Resumo da compra</h3>
            <table>
              <tr>
                <td>Volume</td>
                <td class="desc">{{ getVolume }}</td>
              </tr>
              <tr>
                <td>Percentual de Compensação</td>
                <td class="desc">{{ checkout.liabilityPercentage }}%</td>
              </tr>
              <tr>
                <td>Plano indicado pela eu<b>reciclo</b></td>
                <td class="desc">Plano {{ planName }}</td>
              </tr>
            </table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8">
            <h4>Materiais a compensar</h4>
            <ul class="material-list">
              <li
                v-for="(material, i) in checkout.materials"
                :key="i"
                :class="material.material_name"
              >
                <div>
                  <v-img :src="material.img" contain />
                  <h5>{{ material.material }}</h5>
                </div>
                <p>{{ material.description }}</p>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" md="4" class="total-wrapper">
            <h4>Investimento</h4>
            <h5>
              Total Boleto: <span>{{ getPrice('BANK_SLIP') }}</span>
            </h5>
            <h4
              style="
                font-family: 'metropolisregular';
                font-weight: normal;
                font-size: 16px;
                line-height: 1;
                color: #003036;
                margin-bottom: 15px;
              "
            >
              ou
            </h4>
            <h5>
              Total Cartão:
              <span>{{ getPrice('CARD') }}</span>
            </h5>
            <p>
              Se tudo estiver certo, avance para ser redirecionado para nossa
              área de pagamento.
            </p>
            <p>
              Depois de confirmar o pagamento vamos te enviar um e-mail com
              detalhes da sua compra e seu contrato.
            </p>
            <v-img :src="require('@/assets/images/checkout/formas-pgto.png')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h4>Estado selecionado para a compensar as embalagens</h4>
            <ul class="states-list">
              <li v-for="(state, i) in getStates" :key="i">
                {{ state.name }}
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </HighlightContainerCheckout>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UtilsProvider from '@/providers/UtilsProvider';
import PLANPRICES_CONST from '@/constants/PlanPrices';

export default {
  name: 'Step5',
  components: {
    HighlightContainerCheckout: () =>
      import('@/components/HighlightContainerCheckout.vue'),
  },
  data() {
    return {
      plans: PLANPRICES_CONST.DEFAULT,
      planName: '',
      selectedStates: [],
    };
  },
  computed: {
    getStates() {
      return this.$store.getters.getStates;
    },
    ...mapState(['checkout']),
    getSelectedPlan() {
      return this.$store.getters.getSelectedPlan;
    },
    getVolume() {
      switch (this.checkout.planData.plan_id) {
        case 'feather':
          return '2,3t';
        case 'lightwt':
          return '4,5t';
        case 'average':
          return '9,2t';

        default:
          return false;
      }
    },
  },
  watch: {},
  beforeMount() {},
  mounted() {
    this.getPlanShortName();
  },
  methods: {
    getPlanShortName(sName = null) {
      if (sName === null) {
        const planSelected = this.plans.filter(item => {
          if (
            item.link.split('=')[1].split('&')[0] === this.$route.query.plan
          ) {
            return item;
          }
          return '';
        });
        this.planName = planSelected[0].shortName;
      } else {
        this.planName = sName;
      }
    },
    encurtaNome(state) {
      return state.substring(3);
    },
    getPrice(paymentType) {
      if (paymentType === 'BANK_SLIP') {
        return `R$ ${
          UtilsProvider.formatReal(
            this.getSelectedPlan.year_plan.bank_slip.price_after_discount,
          ) || 0
        } / Ano`;
      }
      return `R$ ${
        UtilsProvider.formatReal(
          this.getSelectedPlan.month_plan.credit_card.price_after_discount,
        ) || 0
      } / Mês`;
    },
  },
};
</script>

<style scoped lang="sass">
@import '@/styles/util'
@import '@/styles/style'

.purchase-summary-wrapper
  h3
    font-family: 'metropolissemi_bold'
    font-weight: normal
    font-size: 24px
    line-height: 1
    color: #003036
    margin-bottom: 35px
  table
    display: block
    width: 100%
    margin-bottom: 24px
    tr
      display: flex
      justify-content: space-between
      align-items: center
      padding: 17px 0px
      border-bottom: 1px solid #72737A
      td
        font-family: 'metropolisbold'
        font-weight: normal
        font-size: 16px
        line-height: 1
        color: #003036
        &.desc
          font-family: 'metropolisregular'
  h4
    font-family: 'metropolisbold'
    font-weight: normal
    font-size: 20px
    line-height: 1
    color: #003036
    margin-bottom: 20px
  .material-list
    list-style-type: none
    padding: 0
    margin: 0
    li
      background: #FFFFFF
      box-shadow: 0px 4px 8px rgba(7, 8, 23, 0.16)
      border-radius: 8px
      margin-bottom: 15px
      &:hover
        box-shadow: 0px 8px 16px rgba(7, 8, 23, 0.16)
      >div
        display: flex
        justify-content: flex-start
        align-items: center
        margin-bottom: 15px
        .v-image
          background: #F2F2F3
          flex-grow: 0
          width: 64px
          height: 64px
          border-radius: 8px 8px 8px 0px
          margin-right: 15px
          ::v-deep
            .v-image__image
              background-size: 33%
        h5
          font-family: 'metropolisbold'
          font-weight: normal
          font-size: 16px
          line-height: 1
          color: #003036
      p
        font-family: 'metropolisregular'
        font-weight: normal
        font-size: 14px
        line-height: 1
        color: #003036
        padding-left: 15px
        padding-bottom: 15px
        &:before
          content: '• '
          color: #003036
          font-size: 14px
          margin-right: 5px
  .total-wrapper
    h5
      display: flex
      flex-direction: row
      justify-content: space-between
      align-items: center
      padding: 16px 32px
      border: 2px solid #003036
      border-radius: 8px
      font-family: 'metropolisbold'
      font-weight: normal
      font-size: 18px
      line-height: 1
      color: #003036
      margin-bottom: 30px
      span
        font-family: 'metropolisregular'
        font-weight: normal
      @media screen and (min-width: 960px) and (max-width: 1280px)
        padding: 16px 10px
        font-size: 16px
    p
      font-family: 'metropolisregular'
      font-weight: normal
      font-size: 16px
      line-height: 1
      color: #003036
      margin-bottom: 15px
      &:before
        content: '• '
        color: #003036
        font-size: 16px
        margin-right: 5px
    .v-image
      max-width: 195px
      margin: 15px auto 0
  .states-list
    display: flex
    flex-wrap: wrap
    list-style-type: none
    padding: 0
    margin: 0
    li
      background: #F2F2F3
      font-family: 'metropolissemi_bold'
      font-weight: normal
      font-size: 16px
      line-height: 1
      color: #003036
      padding: 8px 16px
      margin-right: 15px
      margin-bottom: 15px
      border: 2px solid #CDCDD0
      border-radius: 4px
.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
</style>
